module.exports = "/static/assets/60c04cb50aa0aa4887eecc8cc4d70b47.png";